import { useLoadScript } from '@react-google-maps/api';
import usePlacesAutocomplete, { getGeocode } from 'use-places-autocomplete';
import styles from 'styles/modules/AddressSearch.module.scss';
import { useState } from 'react';
import { parseAddress } from 'helpers/address';
import { profile } from 'lang/en.json';

const googleMapsConfig = {
    googleMapsApiKey: 'AIzaSyDP0GVp9O95-FSauY7rXorc_40HG9fjzms',
    language: 'en-GB',
    libraries: ['places'],
};

export default function AddressSearch({
    onUpdate,
    placeholder,
    label,
    labelAbove,
    register,
    name,
}) {
    const { isLoaded, loadError } = useLoadScript(googleMapsConfig);

    let showElem = (
        <Search
            onUpdate={onUpdate}
            placeholder={placeholder}
            label={label}
            labelAbove={labelAbove}
            register={register}
            name={name}
        />
    );
    if (loadError) showElem = <p>Error</p>;
    if (!isLoaded) showElem = <p>Loading...</p>;

    return <div className={styles.wrapper}>{showElem}</div>;
}

function Search({ onUpdate, placeholder, label, labelAbove, register, name }) {
    const {
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete();

    const [showResults, setShowResults] = useState(false);

    const handleInput = (e) => {
        const val = e.target.value;
        setValue(val);
    };

    const handleSelect = async (item) => {
        setValue(item.description, false);
        clearSuggestions();

        try {
            const results = await getGeocode({ address: item.description });

            if (results.length > 0) {
                let parsedAddress = parseAddress(results[0]);
                parsedAddress.fullAddress = item.description;

                onUpdate(parsedAddress);
                setValue('');
                clearSuggestions();
                setShowResults(false);
            } else {
                alert('error');
            }
        } catch (error) {
            console.error(error); // eslint-disable-line
        }
    };

    return (
        <>
            <div
                className={[
                    styles.inputWrapper,
                    labelAbove ? styles.hasLabelAbove : '',
                ].join(' ')}
            >
                {labelAbove && label && (
                    <label className={styles.labelAbove}>{label}</label>
                )}
                <input
                    type="text"
                    name={name}
                    onChange={handleInput}
                    placeholder={
                        placeholder ?? profile.header.address.sidebar.search
                    }
                    className={[
                        styles.input,
                        labelAbove ? styles.hasLabelAbove : '',
                    ].join(' ')}
                    value={value}
                    onFocus={() => {
                        setShowResults(true);
                    }}
                    ref={register}
                />
                {!labelAbove && label && <label>{label}</label>}
            </div>
            {status === 'OK' && showResults && (
                <div className={['border-gray', styles.results].join(' ')}>
                    {data.map((item) => {
                        return (
                            <div
                                key={item.place_id}
                                onClick={() => handleSelect(item)}
                                className={styles.resultsItem}
                            >
                                {item.description}
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
}
